import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '@/components/onboarding/OnboardingPage';

export const Route = createFileRoute('/onboarding')({
  validateSearch: (search: Record<string, unknown>) => ({
    shopify: search.shopify as string | undefined,
    billing: search.billing as string | undefined,
  }),
  component: OnboardingPage,
});
